import React, {Component} from 'react';

class Contact extends Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {

    };

    render() {
        return (

            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                        Contact Us
                    </div>
                </div>
            </div>
        );
    }
}

export default Contact;